let encryptionPayload = null;

export const setEncryptionPayload = (val) => {
  encryptionPayload = val;
};

export const getEncryptionPayload = () => encryptionPayload;
